<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="units-grid-scroll-frame w-full max-w-full overflow-x-auto overflow-y-hidden">
  <p-table
    #unitsGridTable
    [value]="tableRows()"
    [styleClass]="'units-grid-table ' + tableClass()"
    [tableStyle]="{ 'min-width': tableMinWidth() }"
    [appAutoTableHeight]="autoHeight()"
    [appAutoTableHeightContainerSelector]="autoHeightContainerSelector()"
    [appAutoTableHeightOffset]="autoHeightOffset()"
    [appAutoTableHeightDefault]="autoHeightDefault()"
    [appAutoTableHeightMin]="autoHeightMin()"
    (appAutoTableHeightChange)="onAutoTableHeightChange($event)"
    [scrollable]="enableScroll()"
    [scrollHeight]="getScrollHeight()"
    [virtualScroll]="useVirtualScroll()"
    [virtualScrollItemSize]="virtualScrollItemSize()"
    showGridlines
    stripedRows
  >
  <ng-template pTemplate="header">
    <tr>
      @if (enableExcelExport() || showRowNumbers()) {
        <th class="w-[35px]">
          @if (enableExcelExport()) {
            <p-button
              type="button"
              size="small"
              title="Download Excel"
              icon="pi pi-download"
              (click)="exportToExcel()"
            ></p-button>
          }
        </th>
      }

      @for (column of columns(); track column.field) {
        <th
          class="whitespace-nowrap align-middle"
          (click)="onHeaderClick($event, column)"
          (contextmenu)="onHeaderContextMenu($event, column)"
          [class.highlight-column-header]="isHeaderSelected(column.field)"
        >
          {{ getHeader(column) }}
        </th>
      }

      <th class="w-[50px] text-center">
        <p-button
          class="outlined-button"
          label="Reset"
          size="small"
          severity="danger"
          [outlined]="true"
          (click)="resetRowsData()"
          title="Clears all form data and resets table"
        ></p-button>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
    <tr>
      @if (enableExcelExport() || showRowNumbers()) {
        <td
          class="w-[35px] text-left font-medium"
          (contextmenu)="onCellContextMenu($event, rowIndex, 0)"
        >
          {{ rowIndex + 1 }}
        </td>
      }

      @for (column of columns(); track column.field; let columnIndex = $index) {
        <td
          [attr.data-grid-row]="rowIndex"
          [attr.data-grid-col]="columnIndex"
          [class.highlight-column]="isHeaderSelected(column.field)"
          (click)="onCellClick()"
          (contextmenu)="onCellContextMenu($event, rowIndex, columnIndex)"
          (keydown.tab)="onCellTab($event, rowIndex, columnIndex)"
          (keydown.enter)="onCellEnter($event, rowIndex, columnIndex)"
          [pEditableColumn]="isNumericColumn(column) && isEditable(column) ? row : null"
          [pEditableColumnField]="column.field"
          [pEditableColumnRowIndex]="rowIndex"
        >
          @if (isNumericColumn(column) && isEditable(column)) {
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-inputNumber
                  mode="decimal"
                  [formControl]="asFormControl(getControl(row, column.field))"
                  [style]="{ width: '100%' }"
                  [inputStyle]="{ width: '100%' }"
                  [minFractionDigits]="getMinFractionDigits(column)"
                  [maxFractionDigits]="getMaxFractionDigits(column)"
                  [min]="column.min"
                  [max]="column.max"
                  [invalid]="shouldShowValidationError(row, column)"
                  [title]="shouldShowValidationError(row, column) ? getValidationMessage(getControl(row, column.field)) : ''"
                  [pTooltip]="getCellTooltip(row, column, rowIndex)"
                  (onFocus)="onInputFocus($event)"
                  (onBlur)="onCellBlur(rowIndex, column, getControl(row, column.field))"
                  (paste)="onCellPaste($event, rowIndex, columnIndex)"
                  class="w-full"
                />
              </ng-template>

              <ng-template pTemplate="output">
                <div class="units-grid-cell-output flex items-center gap-1">
                  <span>{{ getCellDisplayValue(row, column) }}</span>
                  @if (showValidation()) {
                    <app-validation-error
                      [isValid]="shouldShowValidationError(row, column)"
                      [errorMsg]="getValidationMessage(getControl(row, column.field))"
                    />
                  }
                </div>
              </ng-template>
            </p-cellEditor>
          } @else {
            <span>{{ getCellDisplayValue(row, column) }}</span>
          }
        </td>
      }

      @if (allowDeleteRows()) {
        <td class="text-center">
          @if (getRowActionLabel(row, rowIndex); as actionLabel) {
            @if (getRowActionIconSrc(row, rowIndex); as actionIconSrc) {
              <div class="flex items-center justify-center">
                <svg-icon
                  [src]="actionIconSrc"
                  [svgStyle]="{ 'width.px': 17 }"
                  class="tree-icon h-[17px] w-[17px] cursor-help"
                  [pTooltip]="actionLabel"
                  tooltipPosition="right"
                ></svg-icon>
              </div>
            } @else {
              <i
                class="pi pi-info-circle text-red-400 cursor-help text-xs"
                [pTooltip]="actionLabel"
                tooltipPosition="right"
              ></i>
            }
          } @else if (!isCompletelyBlankRow(row, true)) {
            <button
              type="button"
              class="pi pi-trash text-red-400 text-xs"
              tabindex="-1"
              [class.opacity-50]="!canDeleteRow(rowIndex)"
              [disabled]="!canDeleteRow(rowIndex)"
              (click)="onDeleteRow($event, rowIndex)"
            ></button>
          }
        </td>
      } @else {
        <td class="w-[50px]"></td>
      }
    </tr>
  </ng-template>
  </p-table>
</div>

@if (enableContextMenu()) {
  <p-contextMenu #gridContextMenu [model]="contextMenuItems" appendTo="body"></p-contextMenu>
}

@if (enableCompareValues()) {
  <p-contextMenu #gridCompareMenu [model]="compareContextMenuItems" appendTo="body"></p-contextMenu>
}
